/**
 * Zod schemas for Webhook Wait plugin - instructions, timeout config, and received payload data.
 */
import { z } from "zod";
/**
 * Configuration schema for the webhook wait step type.
 */
export const configSchema = z.object({
    instructions: z.string().default("Waiting for external system..."),
    timeoutMinutes: z.number().min(1).max(10080).nullable().default(null), // Max 1 week
    showWebhookUrl: z.boolean().default(true),
});
/**
 * Data schema for webhook wait step execution.
 */
export const dataSchema = z.object({
    webhookPayload: z.record(z.unknown()).optional(),
    receivedAt: z.string().optional(),
});
export const defaultConfig = {
    instructions: "Waiting for external system...",
    timeoutMinutes: null,
    showWebhookUrl: true,
};
//# sourceMappingURL=schema.js.map